module.exports = __webpack_public_path__ + "img/bangzhu.9741295f.png";